import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Divider, Button, Tabs, Typography, Timeline, Drawer } from 'antd';
// import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Cookies } from 'react-cookie';
import axios from 'axios';
const cookies = new Cookies();
var token = cookies.get('token');
const { Text, Link } = Typography;

const mapStoreToProps = (store) => {
    return {
    };
};

class HistoryUpdate extends Component {

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
    }

    state = {
        show: false,
        data: [],
        noread_data: [],
        apiMore: '',
        loading: false,
        moreLoaded: false,
    }

    componentDidMount() {
        this.props.onRef(this);
        // this.showModal();
    }

    showModal = () => {
        // localStorage.removeItem('update_message_count');
        // localStorage.setItem('update_message_count', this.props.update_message_count);
        // this.fetchAtmeNoRead();
        this.setState({
            show: true
        });
    }

    handleCancel = () => {
        this.setState({
            show: false,
        });
    }

    render() {
        return (
            <>
                <Drawer
                    destroyOnClose
                    title="更新日志"
                    placement="right"
                    // closable={false}
                    open={this.state.show}
                    loading={this.state.loading}
                    onClose={this.handleCancel}
                    width={800}
                >
                    <Timeline
                        // items={[
                        //     {
                        //         children: 'Create a services site 2015-09-01',
                        //     },
                        //     {
                        //         children: 'Solve initial network problems 2015-09-01',
                        //     },
                        //     {
                        //         children: 'Technical testing 2015-09-01',
                        //     },
                        //     {
                        //         children: 'Network problems being solved 2015-09-01',
                        //     },
                        // ]}
                        items={this.props.items}
                    />
                </Drawer>
            </>
        );
    }
}

export default connect(mapStoreToProps)(HistoryUpdate);